import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaFileArchive } from "react-icons/fa";
import NavbarAdminLealtad from "../NavbarAdminLealtad/NavbarAdminLealtad";
import FooterIndex from "../../components/footerHomePage/footerHomePage";

const ListUserProv = () => {
  const [sales, setSales] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // 🔹 Nuevo estado para el input
  const typeDocument = "Convenio";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_GET_ALL_SUPPLIER_LEALTAD
      );

      // 🔹 Filtrar solo los proveedores con status "Alta"
      const filteredData = response.data.filter(
        (item) => item.status === "Alta"
      );

      setSales(filteredData);
    } catch (error) {
      console.error("Error al obtener proveedores:", error);
    }
  };

  const DowloadPDFTerm = async (e, id) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_TERMS_GET_SUPPLIER_LEALTAD}${id}`;
    try {
      const response = await axios.get(url, { responseType: "arraybuffer" });

      if (response.status === 200) {
        let contentType = response.headers["content-type"].split(";")[0];
        const fileExtension = contentType.split("/")[1];
        const fileName = `${typeDocument}.${fileExtension}`;
        const blob = new Blob([response.data], { type: contentType });
        const fileUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(fileUrl);
      } else if (response.status === 404) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Parece que la firma de este socio no está disponible",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error al obtener el archivo del servidor",
        });
      }
    } catch (error) {
      if (error.response) {
        // 🔹 Aquí capturamos todos los errores HTTP
        if (error.response.status === 404) {
          // 404 → Firma no encontrada
          Swal.fire({
            icon: "warning",
            title: "Firma no encontrada",
            text: "Parece que la firma de este socio no está disponible",
          });
        } else {
          // Otros errores HTTP
          Swal.fire({
            icon: "error",
            title: "Error del servidor",
            text: `Error inesperado`,
          });
        }
      }
    }
  };

  // 🔹 Filtrado dinámico seguro (evita errores si algún campo es null)
  const filteredSales = sales.filter((sale) => {
    const name = sale?.nameAndLastName?.toLowerCase() || "";
    const cuit = sale?.cuit?.toLowerCase() || "";
    const term = searchTerm.toLowerCase();

    return name.includes(term) || cuit.includes(term);
  });

  return (
    <div className="backgounrdprovlealtad">
      <NavbarAdminLealtad />
      <div style={{ margin: "20px" }}>
        <input
          type="text"
          placeholder="Buscar por nombre o CUIT..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "16px",
            width: "97%",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginBottom: "-10px",
          }}
        />
      </div>
      <div className="allboxlistprovadminlealtad">
        <div className="alllistprovlealtad">
          <div className="headerlistprovadminlealtad">
            <p
              id="listprovlealtad"
              className="infoprovlistletterlealtad leftlistprevlealtad firtsborderlealtad"
            >
              Nombre del Comercializador
            </p>
            <p
              id="listprovlealtad"
              className="infoprovlistletterlealtad bottonlistprevlealtad"
            >
              Cuit
            </p>
            <p
              id="listprovlealtad"
              className="infoprovlistletterlealtad bottonlistprevlealtad"
            >
              Estado
            </p>
            <p
              id="listprovlealtad"
              className="infoprovlistletterlealtad bottonlistprevlealtad lastborderlealtad"
            >
              Descarga
            </p>
          </div>
          {filteredSales.map((sale, index) => (
            <div
              className="headerlistprovadminlealtad marginlistprovlealtad"
              key={index}
            >
              <p
                id="listprovlealtad"
                className="infoprovlistletterlealtad leftlistprev2lealtad"
              >
                {sale.nameAndLastName}
              </p>
              <p
                id="listprovlealtad"
                className="infoprovlistletterlealtad leftlistprev2lealtad"
              >
                {sale.cuit}
              </p>
              <p
                id="listprovlealtad"
                className="infoprovlistletterlealtad bottonlistprev2lealtad"
              >
                {sale.status}
              </p>
              <p
                id="listprovlealtad"
                className="infoprovlistletterlealtad bottonlistprev2lealtad"
                onClick={(e) => DowloadPDFTerm(e, sale.id)}
                style={{ cursor: "pointer" }}
              >
                <FaFileArchive className="iconprovlealtad" />
              </p>
            </div>
          ))}
        </div>
      </div>
      <FooterIndex />
    </div>
  );
};

export default ListUserProv;
